export const RESERVED_COMMAND_FIELDS = new Set(["name", "run", "fields", "attrs", "rejectedResult"])

export const RESERVED_BINDING_FIELDS = new Set(["key", "cmd", "event", "preventDefault", "fallthrough"])

export const RESERVED_LAYER_FIELDS = new Set(["target", "targetMode", "priority", "bindings", "commands"])
